var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _c("div", { staticClass: "control-label" }, [
      _c(
        "label",
        { attrs: { id: _vm.field_type, for: "label_" + _vm.field_type } },
        [_vm._v("\n            " + _vm._s(_vm.field_name) + "\n        ")]
      ),
    ]),
    _vm._v(" "),
    !_vm.can_edit
      ? _c("div", { staticClass: "simple_text" }, [
          _vm._v("\n        " + _vm._s(_vm.field_val) + "\n    "),
        ])
      : _c("div", { staticClass: "simple_text" }, [
          _c("div", { staticClass: "mem_title" }, [
            _c("div", { staticClass: "text_info d-inline-block" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.field_val) + "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "edit_text d-inline-block pl-1 cursor-pointer",
                on: { click: _vm.edit_text },
              },
              [_c("fa", { attrs: { icon: _vm.faEdit } })],
              1
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }